
export const Roles = [
    { name: 'Администратор', key: 'admin' },
    { name: 'Пользователь', key: 'user' },
]
